export const ObjetToArr = (data) => {
    let arrayResponse = [];
    if (data)
        for (const [key, value] of Object.entries(data)) {
            arrayResponse.push(value)
        }
    return arrayResponse
}